import { Actor, HttpAgent } from '@dfinity/agent';
import { AuthClient } from "@dfinity/auth-client";
import { sha224 } from '@dfinity/principal/lib/esm/utils/sha224';
import { getCrc32 } from '@dfinity/principal/lib/esm/utils/getCrc';
import { Principal } from "@dfinity/agent"; 
import { mooncatparser }  from "./bunny/bunnyparser.js";
import { bunnycolors }  from "./bunny/bunnycolors.js";

/********************************* */
import { idlFactory as icp_bunny_idl, canisterId as icp_bunny_id } from 'dfx-generated/prod_icpbunny';

// Canister Id as an example
const bunnyCanisterId = 'xkbqi-2qaaa-aaaah-qbpqq-cai';
const punkCanisterId  = 'qcg3w-tyaaa-aaaah-qakea-cai';
const bunnyImageCanId = 'emtmi-oyaaa-aaaaf-qaecq-cai';
const financeCanisterID = 'hhf2l-iaaaa-aaaaf-qaeia-cai';

const storage = [];

storage[0] = 'efqhu-yqaaa-aaaaf-qaeda-cai';
storage[1] = 'ecrba-viaaa-aaaaf-qaedq-cai';
storage[2] = 'fp7fo-2aaaa-aaaaf-qaeea-cai';
storage[3] = 'fi6d2-xyaaa-aaaaf-qaeeq-cai';
storage[4] = 'fb5ig-bqaaa-aaaaf-qaefa-cai';

storage[5] = 'fg4os-miaaa-aaaaf-qaefq-cai';
storage[6] = 'ft377-naaaa-aaaaf-qaega-cai';
storage[7] = 'fu2zl-ayaaa-aaaaf-qaegq-cai';
storage[8] = 'f5zsx-wqaaa-aaaaf-qaeha-cai';
storage[9] = 'f2yud-3iaaa-aaaaf-qaehq-cai';
storage[10]= 'emtmi-oyaaa-aaaaf-qaecq-cai';  //Used in Stage0 Testing

/***********************************************/

const agent = new HttpAgent();
let principal = new Principal();

let amountPaid = 0;
var price = 0.0;
let nextAccountID = 0;
let punkCount = 0;
var seconds = 0;
var rareBunnyEnabled = false;
var isPunkHolder = false;
var adoptInProgress = false;


let punkHolder = "mbwk6-bnbhi-2zkk2-limxc-4rjmn-nfli5-rmlcf-omu3w-x6pbe-bqbys-fqe";

var isPrincipalClaimed  = false;
const whitelist = [bunnyCanisterId,punkCanisterId,financeCanisterID,storage[0],storage[1],storage[2],storage[3],storage[4],storage[5],storage[6],storage[7],storage[8],storage[9],];


const bunnyFactory = ({ IDL }) => {
        const Property = IDL.Record({ 'value' : IDL.Text, 'name' : IDL.Text });
        const MintRequest_2 = IDL.Record({
          'url' : IDL.Text,
          'dataurl' : IDL.Text,
          'accountid' : IDL.Text,
          'contentType' : IDL.Text,
          'data' : IDL.Vec(IDL.Nat8),
          'desc' : IDL.Text,
          'name' : IDL.Text,
          'properties' : IDL.Vec(Property),
        });
        const MintRequest = MintRequest_2;
    return IDL.Service({
        'getPrice' : IDL.Func([], [IDL.Nat64], []),
        'getCurrentToken' : IDL.Func([], [IDL.Nat], ['query']),
        'nextAccount' : IDL.Func([], [], []),
        'claim' : IDL.Func([], [IDL.Nat], []),
        'mint' : IDL.Func([MintRequest], [IDL.Nat], []),
        'my_tokens' : IDL.Func([], [IDL.Vec(IDL.Nat)], []),
        'user_tokens' : IDL.Func([IDL.Principal], [IDL.Vec(IDL.Nat)], ['query']),
    });
};


const financeFactory = ({ IDL }) => {

return IDL.Service({
  'getNormalPrice' : IDL.Func([], [IDL.Nat64], ['query']),
  'getPunkPrice' : IDL.Func([], [IDL.Nat64], ['query']),
  'isPunkHolderClaimed' : IDL.Func([IDL.Principal], [IDL.Bool], ['query']),
  'savePrincipal' : IDL.Func([IDL.Principal], [], []),
  'claimedPrincipal' : IDL.Func([], [], []),
  'isClaimed' : IDL.Func([IDL.Principal], [IDL.Bool], ['query']),
  'getAccountIndex' : IDL.Func(
    [IDL.Principal],
    [IDL.Opt(IDL.Nat)],
    ['query'],
  ),
});
};

const bunnyImageFactory = ({ IDL }) => {
  const TokenData_2 = IDL.Record({
    'id' : IDL.Nat,
    'contentType' : IDL.Text,
    'data' : IDL.Vec(IDL.Nat8),
  });
  const TokenData = TokenData_2; 
  return IDL.Service({
    'saveBunny' : IDL.Func([TokenData, IDL.Nat], [IDL.Nat], []),
  });
  };

  
const punkFactory = ({ IDL }) => {
return IDL.Service({
  'user_tokens' : IDL.Func([IDL.Principal], [IDL.Vec(IDL.Nat)], ['query']),
});
};


const icp_bunny = Actor.createActor(icp_bunny_idl, { agent, canisterId: icp_bunny_id });


(async () => {
  nextAccountID = await icp_bunny.nextAccount();
})();



var el = document.getElementById('seconds-counter');


function start() {
  var tick = function(){
    // console.log("Ticket " + seconds);
    seconds += 1;
    el.innerText = "Minting Time " + seconds + " seconds.";
  };

  var timerId = setTimeout(tick, 1000);
  return timerId
};

function stop(timerId) {
  clearTimeout(timerId);
};





(async () => {
  // Canister Ids

  // Make the request
  const isConnected = await window.ic.plug.requestConnect({
    whitelist,
  });

  // Get the user principal id
  const principalId = await window.ic.plug.agent.getPrincipal();

  const financeActor = await window.ic.plug.createActor({
    canisterId: financeCanisterID,
    interfaceFactory: financeFactory,
  });

  document.getElementById("status").innerHTML = " Loading price ...";


  document.getElementById("principal").value = principalId;

  // console.log(document.getElementById("principal").value);

  let principal = document.getElementById("principal").value;

  let userPrincipal = Principal.fromText(principal);

  await financeActor.savePrincipal(userPrincipal);

  const punkActor = await window.ic.plug.createActor({
    canisterId: punkCanisterId,
    interfaceFactory: punkFactory,
  });

  principal = Principal.fromText(punkHolder);
  let punk = document.getElementById("principal").value;

  let testHolder  = await punkActor.user_tokens(principal); 

  // console.log("Test ICPunk Holder = " + testHolder.length);


  // ICPunk Holder
  //"ws7uw-af6nj-2cudb-7ctcv-ej63l-snxtp-opi3j-eowit-qst2p-lyufg-dae";

  let hold = Principal.fromText(punk);
  let myTokens  = await punkActor.user_tokens(hold); 

  var punkCount = myTokens.length;
  
  var punkPrice = await financeActor.getPunkPrice();
  var normalPrice = await financeActor.getNormalPrice();
  isPrincipalClaimed = await financeActor.isClaimed(hold);


  

  

  // console.log("Normal Price = " + normalPrice);
  // console.log("Punk Price = "+ punkPrice);

  // console.log("Is Claimed = "+ isPrincipalClaimed);

  if(punkCount > 0){
    isPunkHolder = true;

    var isClaimed = await financeActor.isPunkHolderClaimed(userPrincipal);

    if(!isClaimed)
    {
      price = punkPrice;
    }
    else
    {
      price = normalPrice;
    }
  }
  else
  {
    price = normalPrice;
  }

  var BigPrice = price;

  if(BigPrice == 20000000)
  {
    price = 0.2;
  }
  if(BigPrice == 35000000)
  {
    price = 0.35;
  }
  /*
  const divisor = BigInt(100000000);

  var priceText = price.toString();

  price = (price/divisor);
  
  var price1 = (price/100000000);
  */
  // console.log(BigPrice);
  // console.log(price);
  
  document.getElementById("status").innerHTML = "";

  // console.log("Is Claimed = "+ isPrincipalClaimed);

  if(isPrincipalClaimed)
  {
    document.getElementById("status").innerHTML = "You have already claimed with Principal " + punk  + " use different account !";
    price = 0;
  }

  //Disable

  price=0;
  document.getElementById("claimButton").disabled = true;
  
  document.getElementById("mint-fee").innerHTML = "Minting Fee :"+ price +" ICP - Send to below Account ID from PlugWallet";

  document.getElementById("mint-fee").innerHTML = "There is no Bunnies left ! Come back soon";
})();

 
//accountID();

/*************************************** */
var mess = document.getElementById("bunnyBody");
mess.style.visibility = "visible";

document.getElementById("passwordcheck").addEventListener("click", () => {
  passwordCheck();
  
});
function passwordCheck() {
  var testV = 1;
  var pass1 = prompt('Please Enter Your Password', ' ');
  while (testV < 3) {
      if (!pass1)
          history.go(-1);
      if (pass1.toLowerCase() == "letmein") {
          alert('You Got it Right!');
          mess = document.getElementById("bunnyBody");
          mess.style.visibility = "visible";

          var pws = document.getElementById("passwordcheck");
          pws.style.visibility = "hidden";

          break;
      }
      testV += 1;
      var pass1 =
          prompt('Access Denied - Password Incorrect, Please Try Again.', 'Password');
  }
  if (pass1.toLowerCase() != "password" & testV == 3)
      history.go(-1);
  return " ";
}

/************************************************/
var stopFlag = false;
var running = false;
var timerId = 0;

function stopBar()
{
	stopFlag  = true;
  running   = false;
  //stop(timerId);
}

function startBar() {

  //timerId = start();

  stopFlag = false;
  running = true;
  if (i == 0) {
    i = 1;
    var elem = document.getElementById("myBar");
    var width = 1;
    var id = setInterval(frame, 50);
    function frame() {
      if(stopFlag)
      {
        running = false;
      	clearInterval(id);
        width = 100;
        elem.style.width = width + "%";
      }
      if (width >= 100) {
        width = 0;
        i = 0;
      } else {
        width++;
        elem.style.width = width + "%";
      }
    }
  }
}

document.getElementById("payment-checker").disabled = true;
function createButton(amount)
{
  
  if(amountPaid < price)
  {
    document.getElementById("status").innerHTML = "There is no transaction found !";
    return 0;
  }

  document.getElementById("status").innerHTML = "";
  var adaptdiv = document.getElementById("adopt");
  if(!document.body.contains(document.getElementById('adoptid')))
  {
      let btn = document.createElement("button");
      btn.innerHTML = "Adopt it !";
      btn.id ='adoptid';
      btn.className = 'btn';
      adaptdiv.appendChild(btn);
  
      btn.onclick = function() {
        
        if(!adoptInProgress)
        {
          adopt();
          adoptInProgress = true;
        }

      }  
  }    

  // Removes an payment-checker from the document.
  try{
    var element = document.getElementById("payment-checker");
    element.parentNode.removeChild(element);
  }
  catch(e)
  {

  }


}
/****************************************** */
async function init()
{
  const authClient = await AuthClient.create();
  if (await authClient.isAuthenticated()) {
    handleAuthenticated(authClient);
  };
};

// Update the count down every 1 second
var x = setInterval(async function() {

  try{
    let tokens = await icp_bunny.remainingTokens();
    document.getElementById("bunnyAvailable").innerHTML = tokens + " Bunnys (=^_^=)	Available !";
 
  }
  catch(err)
  {
    console.error(err);
  }

}, 5000); 


//Account ID
async function accountID()
{
  try {
      const index = document.getElementById("account-index").value.toString();
      const bunnyPrincpal = "vwwmp-om32r-tgzpy-3lx3m-a5qbm-5pst6-xfdoi-gtivj-trcp6-k3dch-5ae";
      const cont_principal = principalToAccountIdentifier(bunnyPrincpal,index);
      document.getElementById("account-name").value = cont_principal;
      
      // // console.log(cont_principal);
    
      connectWallet();
  } catch (error) 
  {
    console.error(error);
  }
  

}

async function internet_login()
{
  const authClient = await AuthClient.create();
  if (await authClient.isAuthenticated()) {
    handleAuthenticated(authClient);
  };

  await authClient.login({
    onSuccess: async () => {
      handleAuthenticated(authClient);
    },
    identityProvider:
      process.env.DFX_NETWORK === "ic"
        ? "https://identity.ic0.app/#authorize"
        : process.env.LOCAL_II_CANISTER,
  });

  async function handleAuthenticated(authClient) {
    const identity = await authClient.getIdentity();
    // // console.log(identity.getPrincipal());
     

    const httpAgent = new HttpAgent({identity});
     
    let principal = new Principal();
    
    const bunny = Actor.createActor(icp_bunny_idl, { httpAgent, canisterId: icp_bunny_id });
    

    principal = Principal.fromBlob(identity.getPrincipal());

    // console.log("Principle Text ");
    // console.log(principal.toText());

   
    // console.log(" Identity Principal Caller")
 
    const saveSeeds = await icp_bunny.getCaller();
    // console.log(saveSeeds);

    principal = Principal.fromBlob(saveSeeds.getPrincipal());

    // console.log("Caller Principle Text ");
    // console.log(principal.toText());
  }
}

document.getElementById("mintAgain").style.display='none';

document.getElementById("mintAgain").addEventListener("click", async () => {

  location.reload();
  /*nextAccountID = await icp_bunny.nextAccount();
  document.getElementById("payment-checker").disabled = false;
  document.getElementById("claimButton").disabled = false;

  if(document.body.contains(document.getElementById('adoptid')))
  {
    var adoptBtn = document.getElementById("adoptid");
    adoptBtn.remove();
  }*/
});

document.getElementById("claimButton").addEventListener("click", async () => {

  if(price > 0)
  {
    generateContributionAccount();

    document.getElementById("payment-checker").disabled = false;
  }
  else
  {
    if(!isPrincipalClaimed)
    {
      document.getElementById("status").innerHTML = "Please wait, Price is still loading....";
    }
  }

});

document.getElementById("my_bunny").addEventListener("click", async () => {

  getMyTokens();
  
});

document.getElementById("my_punks").addEventListener("click", async () => {

  getMyPunks();
  
});

document.getElementById("icp-bunny").addEventListener("click", async () => {
  const accountName = document.getElementById("account-name").value.toString();
  gen(0);
  
});

document.getElementById("cute-bunny").addEventListener("click", async () => {

  document.getElementById("status").innerHTML = "Rare Bunnies still not available !";

  if(rareBunnyEnabled)
  {
    const accountName = document.getElementById("account-name").value.toString();
    gen(1);
  }
  
});

document.getElementById("payment-checker").addEventListener("click", async () => {

 
  checkPayment().then((amountPaid) => createButton(amountPaid))

  // console.log(amountPaid);
  /*
  if(amountPaid >= 0.14)
  {
    document.getElementById("payment-checker").value = " Claim Now !"
    createButton();
  }
  */
});

async function checkPayment()
{
    connectWallet();
    const cont_principal = document.getElementById("account-name").value;
    return checkAccountBalance(cont_principal);
}

const to32bits = num => {
  let b = new ArrayBuffer(4);
  new DataView(b).setUint32(0, num);
  return Array.from(new Uint8Array(b));
}


const principalToAccountIdentifier = (p, s) => {
  const padding = Buffer("\x0Aaccount-id");
  const array = new Uint8Array([
      ...padding,
      ...Principal.fromText(p).toBlob(),
      ...getSubAccountArray(s)
  ]);
  // console.log("Array Start");
  // console.log(array[array.length-1]);
  // console.log(array[array.length-2]);
  // console.log("Array End");


  const hash = sha224(array);
  const checksum = to32bits(getCrc32(hash));
  const array2 = new Uint8Array([
      ...checksum,
      ...hash
  ]);
  return toHexString(array2);
};

const toHexString = (byteArray)  =>{
  return Array.from(byteArray, function(byte) {
    return ('0' + (byte & 0xFF).toString(16)).slice(-2);
  }).join('')
}

const getSubAccountArray = (s) => {
  if (Array.isArray(s)){
    return s.concat(Array(32-s.length).fill(0));
  } else {
    //32 bit number only
    return Array(28).fill(0).concat(to32bits(s ? s : 0))
  }
};


function checkAccountBalance(account)
{
  //account = document.getElementById("contribution-principal").value;
  // console.log("Checking balance");

  var url = "https://rosetta-api.internetcomputer.org/account/balance";

  var xhr = new XMLHttpRequest();
  xhr.open("POST", url);
  
  xhr.setRequestHeader("Accept", "application/json");
  xhr.setRequestHeader("Content-Type", "application/json");
  
  xhr.onreadystatechange = function () {
     if (xhr.readyState === 4) {
        // console.log(xhr.status);
        // console.log(xhr.responseText);
        var obj = JSON.parse(xhr.responseText);
  
        var balance = obj.balances[0].value/100000000;

      // console.log(balance);
      amountPaid = balance;
      // Printing all the values from the resulting object
       var symbol = obj.balances[0].currency.symbol;
  
      createButton(balance);

      return balance;
  
     }};
  
  var data = `{
     "network_identifier":{
        "blockchain":"Internet Computer",
        "network":"00000000000000020101"
     },
     "account_identifier":{
        "address":"${account}"
     }
  }`;

  // console.log(data);
  var obj = JSON.parse(data);
  obj.account_identifier.address = account;
  // console.log(obj)
 
  xhr.send(data);  
}



function getAccountBalance(account)
{
  var url = "https://rosetta-api.internetcomputer.org/account/balance";

  var xhr = new XMLHttpRequest();
  xhr.open("POST", url);
  
  xhr.setRequestHeader("Accept", "application/json");
  xhr.setRequestHeader("Content-Type", "application/json");
  
  xhr.onreadystatechange = function () {
     if (xhr.readyState === 4) {
        // console.log(xhr.status);
        // console.log(xhr.responseText);
        var obj = JSON.parse(xhr.responseText);
  
        var balance = obj.balances[0].value/100000000;
      // console.log(balance);
      // Printing all the values from the resulting object
       var symbol = obj.balances[0].currency.symbol;
  
      document.getElementById("greeting").innerText = account + "\n" + balance +" "+ symbol;
  
     }};generateToniqTokenID
  var data = `{
     "network_identifier":{
        "blockchain":"Internet Computer",
        "network":"00000000000000020101"
     },
     "account_identifier":{
        "address":"${account}"
     }
  }`;

  // console.log(data);
  var obj = JSON.parse(data);
  obj.account_identifier.address = account;
  // console.log(obj)
 
  xhr.send(data);  
}

function getTransactions(account)
{
  var url = "https://rosetta-api.internetcomputer.org/search/transactions";

  var xhr = new XMLHttpRequest();
  xhr.open("POST", url);
  
  xhr.setRequestHeader("Accept", "application/json");
  xhr.setRequestHeader("Content-Type", "application/json");
  
  xhr.onreadystatechange = function () {
     if (xhr.readyState === 4) {
        // console.log(xhr.status);
        // console.log(xhr.responseText);
        var obj = JSON.parse(xhr.responseText);

    // Find out account name exist in the list of transactions
    let text = "";
    for (let i = 0; i < obj.transactions.length; i++) 
    { 
      text = text + "Sender : " + obj.transactions[i].transaction.operations[0].account.address + "\n";
      text = text + "Receiver : " + obj.transactions[i].transaction.operations[1].account.address + "\n";
      text = text + "Amount Sent :" + obj.transactions[i].transaction.operations[0].amount.value/100000000 + "\n";
      text = text + "Amount Received :" + (obj.transactions[i].transaction.operations[1].amount.value/100000000) + "\n";
      text = text + "------------------------------------------------------------------------------------ \n";
    }

    document.getElementById("greeting").innerText = text; 

     }};
  
  var data = `{
     "network_identifier":{
        "blockchain":"Internet Computer",
        "network":"00000000000000020101"
     },
     "account_identifier":{
        "address":"${account}"
     }
  }`;

  // console.log(data);
  var obj = JSON.parse(data);
  obj.account_identifier.address = account;

  // console.log(obj)
  xhr.send(data);  
}

function generateMoonCatImage(catId, size){
  size = size || 10;
  var data = mooncatparser(catId);
  var colors = bunnycolors(catId);
  // console.log("Color = " + colors);

  var canvas = document.createElement("canvas");
  canvas.width = size * data.length;
  canvas.height = size * data[1].length;
  var ctx = canvas.getContext("2d");

  //https://rarity.studio/cats.html

  for(var i = 0; i < data.length; i++){
    for(var j = 0; j < data[i].length; j++){
      var color = data[i][j];
      if(color){
        ctx.fillStyle = color;
        ctx.fillRect(i * size, j * size, size, size);
      }
    }
  }
  return canvas.toDataURL();
}



function decimalToHexString(number)
{
  if (number < 0)
  {
    number = 0xFFFFFFFF + number + 1;
  }

  return number.toString(16).toUpperCase();
}
function random(max) {
    return Math.floor(Math.random() * max) + 1;
}
function gen(genesis)
{
    const random_hex_color_code = () => {
      let n = (Math.random() * 0xaaaaa * 12345678).toString(16);
      
      var rand = random(255);      
      // console.log("N value = "+ n + " Random Body ="+ rand);

      if(genesis)
      {
        return 'df' + decimalToHexString(rand) + n.slice(0, 8);
      }
     else
     {
        return 'df00' + decimalToHexString(rand) + n.slice(0, 6);
     }
    };

    document.getElementById("bunnyid").value = random_hex_color_code(); 
    
    var span = document.getElementById("bunny_meta_data");
    span.textContent = document.getElementById("bunnyid").value;
    
    var catid = document.getElementById("bunnyid").value;
    let img = generateMoonCatImage(catid,100);
    document.getElementById("bunny").src= img;	
}

function genBunny(genesis)
{
    const random_hex_color_code = () => {
      let n = (Math.random() * 0xaaaaa * 12345678).toString(16);
      //var rand = random(255);

      var rand = document.getElementById("bunny-index").value.toString();

      if(genesis)
      {
        return 'df' + decimalToHexString(rand) + n.slice(0, 8);
      }
     else
     {
        return 'df00' + decimalToHexString(rand) + n.slice(0, 6);
     }
    };

    document.getElementById("bunnyid").value = random_hex_color_code(); 
    
}


function tableCreate() {
  var body = document.getElementsByTagName('body')[0];
  var tbl = document.getElementById('nft');
  tbl.style.width = '100%';
  tbl.setAttribute('border', '0');
  var tbdy = document.createElement('tbody');
  var genesis = true;
  for (var i = 0; i < 5; i++) {
    var tr = document.createElement('tr');
    for (var j = 0; j < 5; j++) {
        if(genesis)
          genesis = false;
        else
          genesis = false;
        genBunny(genesis);
        var td = document.createElement('td');

        var span = document.createElement("span");
        var image = document.createElement("img");

        var bunnyid = document.getElementById("bunnyid").value;
        var bunny   = document.createTextNode(bunnyid + ' ');
        // console.log(bunnyid);

        let img = generateMoonCatImage(bunnyid,8);
        image.src= img;	
        td.appendChild(bunny);
        span.appendChild(image);
        td.appendChild(span)
        tr.appendChild(td)
    }
    tbdy.appendChild(tr);
  }
  tbl.appendChild(tbdy);
  body.appendChild(tbl)
}


/*
var genesis = false;
for (let i = 0; i < 10; i++) {

  gen(genesis);
  if(genesis)
    genesis = false;
  else
    genesis = true;
}
*/

/*
function loadXHR(url) {

  return new Promise(function(resolve, reject) {
      try {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url);
          xhr.responseType = "blob";
          xhr.onerror = function() {reject("Network error.")};
          xhr.onload = function() {
              if (xhr.status === 200) {resolve(xhr.response)}
              else {reject("Loading error:" + xhr.statusText)}
          };
          xhr.send();
      }
      catch(err) {reject(err.message)}
  });
  }
  
  loadXHR("https://e3izy-jiaaa-aaaah-qacbq-cai.raw.ic0.app/?tokenid=ali4h-rikor-uwiaa-aaaaa-b4aaq-maqca-aaade-a").then(function(blob) {
      // console.log(blob);
   
      var arrayBuffer;
      var fileReader = new FileReader();
      fileReader.onload = function(event) {
      arrayBuffer = event.target.result;
      // console.log(arrayBuffer);
  
      const songDataArray = Array.from(new Uint8Array(arrayBuffer));
      // console.log(songDataArray);
  
      let NewArrayBuffer = new Uint8Array(songDataArray);
  
      // console.log(NewArrayBuffer);
  
      const bufferBlob = new Blob([NewArrayBuffer], {
      type: "image/svg+xml",});   
  
      const bufferBlob2 = new Blob([NewArrayBuffer], {
      type: "octet/stream",});   // Not working
  
      
  
      // console.log(bufferBlob);
  
      var bufferImage = URL.createObjectURL(bufferBlob);
      const bufferImg = document.createElement('img');
      bufferImg.width = 200;
      bufferImg.height = 200;
      bufferImg.src = bufferImage;
  
      document.body.appendChild(bufferImg);
  
      };
      fileReader.readAsArrayBuffer(blob);
  
  });

*/

/*
Here we have bunny generated image. Once we have the image in the canvas
We can use that image generate blob

Done 1.Bunny is generated with moontCatParser.js 
Done 2.Bunny is in Canvas now
Done 3.Loaded in image tag User can see the Bunny now.
4.When selected for Adoption, it will be converted to Numbers NAT array

User will make the payment. Once paid we need to send the paid Account Identifier to the canister
When the canister receives and stores to verify while minting the NFT

5.Send to canister NAT data/Blob, Token Identifier, Token ID,AccountIdentifier
6.Canister verifiers whether amount is received from the AccountIdentifier


We should have hashmap to store
1.AccountID and Contribution Address
When ever an Account Id is entered same contribution address should be displayed


Then the NFT is associated with that Account Identifier

When downloading canister will be called as

http://canister-id.localhost:80000/?tokenid=ali4h-rikor-uwiaa-aaaaa-b4aaq-maqca-aaade-a

1.Parse the Token ID 
2.Get the Token index
3.Return the Image
*/
/**************************************************************/

function dataURLToBlob(dataURL) {
  var BASE64_MARKER = ';base64,';

  if (dataURL.indexOf(BASE64_MARKER) == -1) {
      var parts = dataURL.split(',');
      var contentType = parts[0].split(':')[1];
      var raw = decodeURIComponent(parts[1]);

      return new Blob([raw], {type: contentType});
  }

  var parts = dataURL.split(BASE64_MARKER);
  var contentType = parts[0].split(':')[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;

  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], {type: contentType});
}
/**************************************************************/
function blobToImage(blob)
{
  // Image to Blob

  var arrayBuffer;
  var fileReader = new FileReader();
  fileReader.onload = function(event) {
  arrayBuffer = event.target.result;

  // console.log("Inside...");
  // console.log(arrayBuffer);

  const songDataArray = Array.from(new Uint8Array(arrayBuffer));
  // console.log(songDataArray);
  //const result1 = await mugatunes.putSongChunk(song,id,chunk);

  //////////////// Now convert back to image 
  //let rawDataArray = JSON.parse( "[" + nestedBytes + "]"); // Important step
  let NewArrayBuffer = new Uint8Array(songDataArray);

  // console.log(NewArrayBuffer);

  const bufferBlob = new Blob([NewArrayBuffer], {
  type: "image/png",});   
 

  // console.log(bufferBlob);

  var bufferImage = URL.createObjectURL(bufferBlob);
  const bufferImg = document.createElement('img');
  bufferImg.width = 200;
  bufferImg.height = 200;
  bufferImg.src = bufferImage;

  document.body.appendChild(bufferImg);

  };
  fileReader.readAsArrayBuffer(blob);    
}
/**************************************************************/
var tokenId = 1;
/**************************************************************/

async function make_request() {

  var trait =  {"Background": "Grey", "Body": "White", "Top": "Top", "Head": "head", "Eyes": "nose", "Nose": "White", "Mouth": "Holy Water", "tokenId": tokenId}
  let bunny = document.getElementById("bunny").src;

  tokenId++;
  const bunnyBlob = dataURLToBlob(bunny);
  // console.log(bunnyBlob);

  var bufferPromise = bunnyBlob.arrayBuffer();

  bunnyBlob.arrayBuffer().then(buffer => {});

  var buffer = await bunnyBlob.arrayBuffer();
  const songDataArray = Array.from(new Uint8Array(buffer));

  // console.log(songDataArray);

  var account_name =  document.getElementById("account-name").value;
  const bunnyID = document.getElementById("bunnyid").value.toString();


  var mintRequest = {
    name: "ICPBunny #" + (trait.tokenId + 1),
    url: "/Token/" + (trait.tokenId + 1),
    dataurl:"/Token/" + (trait.tokenId + 1),
    contentType: "image/png",
    accountid: account_name,
    data: songDataArray, //data,
    desc: bunnyID,
    properties: [
      { name: 'Background', value: trait.Background },
      { name: 'Body', value: trait.Body },
      { name: 'Nose', value: trait.Nose },
      { name: 'Mouth', value: trait.Mouth },
      { name: 'Eyes', value: trait.Eyes },
      { name: 'Head', value: trait.Head },
      { name: 'Top', value: trait.Top },
    ]
  };
  return mintRequest;
}


async function claimRequest() {

  let bunny = document.getElementById("bunny").src;

  const bunnyBlob = dataURLToBlob(bunny);
  // console.log(bunnyBlob);

  var bufferPromise = bunnyBlob.arrayBuffer();

  bunnyBlob.arrayBuffer().then(buffer => {});

  var buffer = await bunnyBlob.arrayBuffer();
  const bunnyDataArray = Array.from(new Uint8Array(buffer));

  // console.log(bunnyDataArray);

  var claimRequest_ = {
    'id' : 1,
     contentType: "image/png",
     data: bunnyDataArray, 
  };
 
  return claimRequest_;
}
/*************************************************************/
function generateToniqTokenID(index)
{ 
  // Generate UNIQU ID for Toniq Labs
  // console.log("Generate UNIQU ID for Toniq Labs");
  let principal = "e3izy-jiaaa-aaaah-qacbq-cai";
  index         = 100;

  const padding = Buffer("\x0Atid");


  const array = new Uint8Array([
    ...padding,
    ...Principal.fromText(principal).toUint8Array(),
    ...ToUint32(index),
  ]);

  let bunnyAddress = Principal.fromUint8Array(array).toText();
  // console.log("Bunny Toniq Address = ");
  // console.log(bunnyAddress);
}
/******************************************************/

function  connectWallet()
{
    var principalId = document.getElementById("principal").value;

    // Always first account
    const cont_principal = principalToAccountIdentifier(principalId,0); 

    // console.log("principalId = " + cont_principal);
    document.getElementById("useraccountname").value = cont_principal;
   
}

async function  getMyTokens()
{
   
    await window?.ic?.plug?.requestConnect({
      bunnyCanisterId,
      host:"https://mainnet.dfinity.network",
    });
  
  // Create an actor to interact with the NNS Canister
  // we pass the NNS Canister id and the interface factory
  const bunnyActor = await window.ic.plug.createActor({
    canisterId: bunnyCanisterId,
    interfaceFactory: bunnyFactory,
  });

    let plugPrincipal = document.getElementById("principal").value;
    
    let userPrincipal = Principal.fromText(plugPrincipal);
    let myTokens  = await bunnyActor.user_tokens(userPrincipal);   

    // console.log(plugPrincipal);

    var arrayLength = myTokens.length;
    // console.log("Comparision happens now");

    if(arrayLength == 0)
    {
      // console.log("Array length is Zero");

      var body = document.getElementById('bunnynft');
      var tbl = document.getElementById('nft');
      tbl.style.width = '100%';
      tbl.setAttribute('border', '0');
      var tbdy = document.createElement('tbody');
      var genesis = true;


      try{
        document.getElementById("count-1").remove();
      }
      catch(e){}

      var tr = document.createElement('tr');
      tr.setAttribute("id", "count-1");
      var td = document.createElement('td');
      var a = document.createElement('a');
      var linkText = document.createTextNode("You have "+ arrayLength + " ICPBunny");
      a.appendChild(linkText);
      a.title = "ICPBunny " + arrayLength;
      a.href = "#";       
      td.appendChild(a)
      tr.appendChild(td)       
      tbdy.appendChild(tr);
      tbl.appendChild(tbdy);
      body.appendChild(tbl)        
    }

    for (var i = 0; i < arrayLength; i++) {
      

      {
        var body = document.getElementById('bunnynft');
        var tbl = document.getElementById('nft');
        tbl.style.width = '100%';
        tbl.setAttribute('border', '0');
        var tbdy = document.createElement('tbody');
        var genesis = true;
        for (var i = 0; i < arrayLength; i++) {

          try{
            document.getElementById("b-"+i).remove();
          }
          catch(e){}

          var tr = document.createElement('tr');
          tr.setAttribute("id", "b-"+i);
          
          var td = document.createElement('td');
  
          var a = document.createElement('a');
          var linkText = document.createTextNode("Bunny " + myTokens[i]);
          a.appendChild(linkText);
          a.title = "Bunny " + myTokens[i];

          let canister = (myTokens[i]%10n);
          // console.log(storage[canister]);

          a.href = "https://"+ storage[canister] +".raw.ic0.app/Token/"+ (myTokens[i]);
          a.target = myTokens[i];

          td.appendChild(a)
          tr.appendChild(td)
         
          tbdy.appendChild(tr);
        }
        tbl.appendChild(tbdy);
        body.appendChild(tbl)
      }
    }

    // console.log("My Tokens Size" + arrayLength);
    // console.log(myTokens);
}



async function  getMyPunks() 
{
   
    await window?.ic?.plug?.requestConnect({
      punkCanisterId,
      host:"https://mainnet.dfinity.network",
    });
  
  // Create an actor to interact with the NNS Canister
  // we pass the NNS Canister id and the interface factory
  const punkActor = await window.ic.plug.createActor({
    canisterId: punkCanisterId,
    interfaceFactory: punkFactory,
  });

    principal = Principal.fromText("mbwk6-bnbhi-2zkk2-limxc-4rjmn-nfli5-rmlcf-omu3w-x6pbe-bqbys-fqe");
    let punk = document.getElementById("principal").value;

    let testHolder  = await punkActor.user_tokens(principal); 
    // console.log("Test ICPunk Holder = " + testHolder.length);


    // ICPunk Holder
    //"ws7uw-af6nj-2cudb-7ctcv-ej63l-snxtp-opi3j-eowit-qst2p-lyufg-dae";

    let hold = Principal.fromText(punk);
    let myTokens  = await punkActor.user_tokens(hold); 

    var arrayLength = myTokens.length;
    punkCount = myTokens.length;

    if(arrayLength == 0)
    {
      var body = document.getElementById('punknft');
      var tbl = document.getElementById('pnft');
      tbl.style.width = '100%';
      tbl.setAttribute('border', '0');
      var tbdy = document.createElement('tbody');
      var genesis = true;


      try{
        document.getElementById("count-1").remove();
      }
      catch(e){}

      var tr = document.createElement('tr');
      tr.setAttribute("id", "count-1");
      var td = document.createElement('td');
      var a = document.createElement('a');
      var linkText = document.createTextNode("You have "+ punkCount + " ICPunks");
      a.appendChild(linkText);
      a.title = "ICPunk " + arrayLength;
      a.href = "#";       
      td.appendChild(a)
      tr.appendChild(td)       
      tbdy.appendChild(tr);   
      tbl.appendChild(tbdy);
      body.appendChild(tbl)              
    }


    for (var i = 0; i < arrayLength; i++) {
    
      {
        var body = document.getElementById('punknft');
        var tbl = document.getElementById('pnft');
        tbl.style.width = '100%';
        tbl.setAttribute('border', '0');
        var tbdy = document.createElement('tbody');
        var genesis = true;


        try{
          document.getElementById("count-1").remove();
        }
        catch(e){}

        var tr = document.createElement('tr');
        tr.setAttribute("id", "count-1");
        var td = document.createElement('td');
        var a = document.createElement('a');
        var linkText = document.createTextNode("You have "+ punkCount + " ICPunks");
        a.appendChild(linkText);
        a.title = "ICPunk " + arrayLength;
        a.href = "#";       
        td.appendChild(a)
        tr.appendChild(td)       
        tbdy.appendChild(tr);        


        for (var i = 0; i < arrayLength; i++) {

          try{
            document.getElementById("p-"+i).remove();
          }
          catch(e){}

          var tr = document.createElement('tr');
          tr.setAttribute("id", "p-"+i);

          var td = document.createElement('td');
  
          var a = document.createElement('a');
          var linkText = document.createTextNode("ICPunk " + myTokens[i]);
          a.appendChild(linkText);
          a.title = "ICPunk " + myTokens[i];
          a.href = "https://qcg3w-tyaaa-aaaah-qakea-cai.raw.ic0.app/Token/"+ myTokens[i];
          a.target = myTokens[i];

          td.appendChild(a)
          tr.appendChild(td)
         
          tbdy.appendChild(tr);
        }
        tbl.appendChild(tbdy);
        body.appendChild(tbl)
      }
    }

    // console.log("My Tokens");
    // console.log(myTokens);
}

async function  generateContributionAccount()
{

    
    await window?.ic?.plug?.requestConnect({
      whitelist,
      host:"https://mainnet.dfinity.network",
    });
  
  // Create an actor to interact with the NNS Canister
  // we pass the NNS Canister id and the interface factory
  const financeActor = await window.ic.plug.createActor({
    canisterId: financeCanisterID,
    interfaceFactory: financeFactory,
  });

    //let account_index = await bunnyActor.nextAccount();
    // console.log("Next Account " + nextAccountID);

    let principal = document.getElementById("principal").value;
    let userPrincipal = Principal.fromText(principal);

    nextAccountID = await financeActor.getAccountIndex(userPrincipal);

    // console.log(nextAccountID);

    document.getElementById("account-index").value = nextAccountID;
    accountID();

    /*
    let principal = document.getElementById("principal").value;
    let contributionAccount = await financeActor.getAccount(principal);
    // console.log(principal  + " principal " + contributionAccount);

    document.getElementById("account-name").value = contributionAccount;
    */

    //Check is claimed
    //Get PunkPrice
    //Get Normal Price


    document.getElementById("mint-fee").innerHTML = "Minting Fee :"+ price +" ICP - Send to below Account ID from PlugWallet";
}

async function  adopt()
{
    //// console.log("Bunny Toniq Address = ");
    //generateToniqTokenID(100);

    // Only base64 String
    startBar();
    // console.log("Minting Process");

    
   
    await window?.ic?.plug?.requestConnect({
      whitelist,
      host:"https://mainnet.dfinity.network",
    });
  
  



  // Create an actor to interact with the NNS Canister
  // we pass the NNS Canister id and the interface factory
  const bunnyActor = await window.ic.plug.createActor({
    canisterId: bunnyCanisterId,
    interfaceFactory: bunnyFactory,
  });




  var _claimRequest = await claimRequest();

  // console.log(_claimRequest);
  
  var isClaimed = 0;
  var isMinted = 0;


  try {

    //isMinted = await bunnyActor.mint(mintRequest);
    
    isClaimed = await bunnyActor.claim();


    let canisterIndex       = (isClaimed % 10n);
    let storageCanister     = storage[canisterIndex];


    // console.log("Currently claimed Bunny " + isClaimed);
    // console.log("Currently canisterIndex " + canisterIndex);
    // console.log("Currently storageCanister " + storageCanister);
    

    const bunnyStorage = await window.ic.plug.createActor({
      canisterId: storageCanister,
      interfaceFactory: bunnyImageFactory,
    });

    isMinted = await bunnyStorage.saveBunny(_claimRequest,isClaimed);

    const financeActor = await window.ic.plug.createActor({
      canisterId: financeCanisterID,
      interfaceFactory: financeFactory,
    });

    await financeActor.claimedPrincipal();
  
    document.getElementById("adoptid").disabled = true;
    

    if(isMinted > 0)
    {
      document.getElementById("mintAgain").style.display='block';
      stopBar();
      if(isMinted == 10001)
      {
        document.getElementById("status").innerHTML = "Oh, ICP you sent is little lesser send the remaining amount !";
      }      
      else{
        let bunnyLink = "<a target='_' href='https://"+storageCanister+".raw.ic0.app/Token/"+isMinted + "'>Your Bunny</a> lives here !";
        
        document.getElementById("status").innerHTML = "Congratulations ! " + bunnyLink;
      }
    }
    else if(isMinted == 0)
    {
      stopBar();
      document.getElementById("status").innerHTML = "Oh, No the Bunny escaped to the moon !";
    }

  }
  catch(err) {
    stopBar();
    console.log(err);
    document.getElementById("status").innerHTML = "Network Error.... " ;
    
    //document.getElementById("status").innerHTML = "Try again ! Report this error -->" + err;
  }

}


var span = document.getElementById("bunny_meta_data");
span.textContent = "df000190416f";

//let img = generateMoonCatImage("df000190416f",100);
//document.getElementById("bunny").src= img;
document.getElementById("bunnyAvailable").innerText = "Reading count...";

//tableCreate();
gen(0); // First Image 

/****************************/



var i = 0;


function countDown()
{
  // Set the date we're counting down to
  var countDownDate = new Date("Sep 24, 2021 06:00:00").getTime();

  // Update the count down every 1 second
  var x = setInterval(function() {

    // Get today's date and time
    var now = new Date().getTime();
      
    // Find the distance between now and the count down date
    var distance = countDownDate - now;
      
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
    // Output the result in an element with id="demo"
    document.getElementById("countdown").innerHTML = days + "d " + hours + "h "
    + minutes + "m " + seconds + "s ";
      
    // If the count down is over, write some text 
    if (distance < 0) {
      clearInterval(x);
      document.getElementById("countdown").innerHTML = "Mint Now !";
    }
  }, 1000); 

}





//countDown();